import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";

export default function SizeGuide({ size_guideData = [] }) {
    if (!size_guideData.length) return null;

    return (
        <>
            <h2 className="tab-section-txt">SIZE GUIDE:</h2>

            <div className="size-guide-block">
                {size_guideData.map((item, index) => (
                    <div className="size_sction_root" key={item?.id || index}>
                        <div className="img_track_runner">
                            <LazyLoadImage
                                className="img-guild-section"
                                src={item?.media}
                                alt={item?.title || "Size guide image"}
                                loading="lazy"
                                effect="blue"
                            />
                        </div>

                        <div className="sector_group_txt">
                            <h4 className="title-size-gid">{item?.title}</h4>

                            {item?.content?.map((con, idx) => (
                                <div key={idx} className="size-guide-row">
                                    <span className="txt-ft">{con?.size}:</span>{" "}
                                    <span className="txt-ft2">
                                        {con?.description}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}

                <div className="size-guide-footer">
                    <span className="pp-mc-txt">
                        Not sure which size fits best? Explore our{" "}
                        <Link
                            to="/size-guide"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="sub-pp-mc"
                            style={{ color: "#000" }}
                        >
                            Size Guide
                        </Link>{" "}
                        to find your perfect match.
                    </span>
                </div>
            </div>
        </>
    );
}
